import ImageGeneratorBlockTool from '@/utils/editorjs/image-generator';
import { ToolSettings } from '@editorjs/editorjs';
import { useTranslation } from 'react-i18next';

type useImageGeneratorToolArgs = {
  onGenerateImage?: (prompt: string) => Promise<string>;
};

export const useImageGeneratorTool = ({
  onGenerateImage,
}: useImageGeneratorToolArgs = {}) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'editorJs',
  });
  const tool: ToolSettings = {
    class: ImageGeneratorBlockTool,
    config: {
      label: t('label.imageGenerator'),
      callbacks: {
        onGenerateImage,
      },
    },
  };
  return {
    tool,
  };
};
